import { Component} from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder,FormGroup, Validators } from "@angular/forms";
import { LoginService } from "../services/login/login.service";
import Swal from "sweetalert2";
import { MustMatch } from '../_helpers/must-match.validator';

@Component({
  selector: 'app-cambiar-acceso',
  templateUrl: './cambiar-acceso.component.html',
  styleUrls: ['./cambiar-acceso.component.css']
})
export class CambiarAccesoComponent   {
  id_user;
  loading: boolean = false;
  data: any;
  form: FormGroup;
  submited:boolean = false;
  constructor(private loginService: LoginService,private router: Router,private _route: ActivatedRoute,private formBuilder: FormBuilder) {
    let user = +this._route.snapshot.paramMap.get('user');
    this.id_user = user;
    sessionStorage.clear();

    this.form = this.formBuilder.group({
      id_usuario: [this.id_user, Validators.required],
        id_empresa: ['1', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        password_confirm: ['', [Validators.required]]
      }, {
          validator: MustMatch('password', 'password_confirm')
      });

   }



  get f() { return this.form.controls; }

  guardarCambios(){
    this.submited = true;
    if (this.form.invalid){
      return;
    }
    
    this.loading = true;
      this.loginService.cambiarContraseña(this.form.getRawValue()).subscribe(
        resp => {
          this.data = resp;
          this.loading = false;
          Swal.fire({
            title: "¡Éxito!",
            text: "La contraseña ha sido modificada correctamente.",
            type: "success",
            allowOutsideClick: true
          }).then(resp1 => {
            if (resp1.value == true){
              this.router.navigate(['/login']);
            }
          }); 

        },
        err => {       
          this.loading = false;
          Swal.fire({
            title: "Error",
            text: "Usuario o Contraseña Incorrectos",
            type: "error",
            allowOutsideClick: true
          });          
        }
      );

  }

}
